class History {
  constructor(options) {
    this.splitChar = '##' // 分隔符
    this.site = options.site || 'cn'
    this.maxVisibleNum = options.maxVisibleNum // 单个最大展示个数
    this.isShowEllipsis = options.isShowEllipsis // 是否显式加上...
    this.version = '1.0' // 根据版本号判断是否需要清除缓存
    this.viewContext = options.viewContext
  }

  /**
   * @description: 判断是否是脏数据
   * @return {*}
   */
  judgeVersion() {
    let cacheData = window.localStorage.getItem('waybill_no')
    if (!cacheData?.includes('{')) {
      return true
    }
    cacheData = JSON.parse(cacheData)
    // 判断版本号不相等
    if (cacheData.version !== this.version) {
      return true
    }
    return false
  }

  /**
   * @description: 根据站点，获取对应站点下历史记录缓存
   * @return {*} Array
   */
  getCache() {
    let temp = []
    if (this.judgeVersion()) {
      window.localStorage.removeItem('waybill_no')
    } else {
      temp = window.localStorage.getItem('waybill_no')
      // 有站点的数据
      temp = JSON.parse(temp)[this.site]
    }
    return (
      temp
        ?.toString()
        ?.split(this.splitChar)
        ?.filter((i) => i) || []
    )
  }

  // 获取本地所有数据的总对象
  getCacheObj() {
    let temp = {}
    if (this.judgeVersion()) {
      window.localStorage.removeItem('waybill_no')
    } else {
      // 有站点的数据
      temp = window.localStorage.getItem('waybill_no')
      temp = JSON.parse(temp)
    }
    return temp
  }

  updateCache(valueArr) {
    // 更新该站点的历史数据
    const hisData = this.getCacheObj()
    hisData[this.site] = valueArr.join(this.splitChar)
    hisData.version = this.version
    window.localStorage.setItem('waybill_no', JSON.stringify(hisData))

    this.viewContext?.initHisData.call(this.viewContext)
  }

  setCache(value) {
    let oldValue = this.getCache()
    oldValue.unshift(value)
    // 去重
    oldValue = Array.from(new Set(oldValue))
    if (oldValue.length > 10) oldValue.pop()
    this.updateCache(oldValue)
  }

  // 获取历史查询展示数据
  getShowDateObj() {
    const oldValue = this.getCache()
    return oldValue.map((item) => {
      const itemArray = item?.split(',')
      let showData = item
      let hiddenCount = 0
      // 如果超过maxVisibleNum项，只展示前maxVisibleNum项，后面展示数字
      const maxVisibleNum = this.maxVisibleNum
      if (itemArray?.length > maxVisibleNum) {
        showData =
          itemArray.slice(0, maxVisibleNum).toString() +
          (this.isShowEllipsis && '...')
        hiddenCount = itemArray.length - maxVisibleNum
      }
      return {
        showData,
        hiddenCount,
        rawData: item,
      }
    })
  }

  deleteHistoryItem(value) {
    const oldValue = this.getCache()
    const newValue = oldValue.filter((item) => {
      return item !== value
    })
    this.updateCache(newValue)
  }
}
export default History
